var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalmart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_48_942)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#B7A2FF",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9666 65.5094L52.5986 68.4654C52.2955 68.7428 52.1085 69.1247 52.0754 69.5343C52.0422 69.9439 52.1653 70.3509 52.42 70.6734C52.932 71.5467 53.828 71.9641 54.42 71.6147L60.1786 67.6001C60.3444 67.4024 60.4387 67.1545 60.4462 66.8966C60.4537 66.6387 60.374 66.3858 60.22 66.1787C60.1179 65.9416 59.9382 65.7462 59.7105 65.6246C59.4828 65.503 59.2205 65.4624 58.9666 65.5094ZM69.036 65.5107C68.636 65.3534 68.1026 65.6441 67.78 66.1841C67.6292 66.3906 67.5508 66.6411 67.5571 66.8966C67.5634 67.1522 67.6539 67.3986 67.8146 67.5974L73.568 71.6214C74.1653 71.9627 75.0653 71.5481 75.5773 70.6734C76.0893 69.7987 75.9893 68.8067 75.3973 68.4654L69.036 65.5107ZM64 68.3614C63.7445 68.3307 63.4862 68.3873 63.2669 68.5218C63.0477 68.6564 62.8803 68.8611 62.792 69.1027L62.1706 76.0827C62.1706 76.7734 62.9786 77.3334 64 77.3334C65.0213 77.3334 65.828 76.7734 65.828 76.0827L65.212 69.1027C65.1227 68.8609 64.9545 68.6563 64.7346 68.5218C64.5147 68.3873 64.2559 68.3308 64 68.3614ZM67.78 61.8227C67.8855 62.0583 68.0658 62.2524 68.2929 62.3751C68.5199 62.4978 68.7811 62.5422 69.036 62.5014L75.404 59.5401C75.996 59.1907 76.084 58.2134 75.584 57.3347C75.084 56.4561 74.172 56.0414 73.5746 56.3827L67.8213 60.4001C67.6595 60.601 67.5684 60.8496 67.5621 61.1075C67.5559 61.3654 67.6348 61.6182 67.7866 61.8267L67.78 61.8227ZM54.4253 56.3854C53.828 56.0361 52.932 56.4521 52.4253 57.3321C52.1707 57.6546 52.0476 58.0616 52.0807 58.4712C52.1138 58.8808 52.3008 59.2627 52.604 59.5401L58.9666 62.4934C59.2202 62.5406 59.4822 62.5004 59.7099 62.3793C59.9376 62.2582 60.1174 62.0634 60.22 61.8267C60.3737 61.6199 60.4532 61.3672 60.4457 61.1096C60.4382 60.8519 60.3441 60.6044 60.1786 60.4067L54.4253 56.3854ZM64 50.6667C62.9786 50.6667 62.1706 51.2321 62.1706 51.9241L62.8 58.9027C62.888 59.1429 63.0541 59.3465 63.2717 59.481C63.4893 59.6154 63.7458 59.6729 64 59.6441C64.2559 59.6747 64.5147 59.6182 64.7346 59.4837C64.9545 59.3492 65.1227 59.1446 65.212 58.9027L65.828 51.9241C65.8293 51.2321 65.016 50.6667 64 50.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_48_942",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_942",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717093 0 0 0 0 0.635577 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_48_942"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmart);
export default __webpack_public_path__ + "static/media/Walmart.cecfa032e2c857d5062b8b1eb5638d98.svg";
export { ForwardRef as ReactComponent };